import { AtMenuConfigService } from '@hive/core/modules/at-menu-config/services';
import type { LinkedWidgetConfig } from '@blocksuite/hive/widgets/linked-doc';
import { type FrameworkProvider } from '@toeverything/infra';

export function createLinkedWidgetConfig(
  framework: FrameworkProvider
): Partial<LinkedWidgetConfig> {
  return framework.get(AtMenuConfigService).getConfig();
}
